module.exports = __webpack_public_path__ + "static/media/opensans-regular.1e1b56e9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-regular.woff2
// module id = 291
// module chunks = 0